import { Menu } from '@mantine/core';
import { Icon, IconButton } from '@repo/foundations';

interface ExportMenuProps {
	handleCopyPng: () => void;
	handleDownloadPng: () => void;
}

export function ExportMenu({
	handleCopyPng,
	handleDownloadPng,
}: ExportMenuProps) {
	return (
		<Menu>
			<Menu.Target>
				<IconButton
					variant="tertiary"
					iconName="download"
					tooltip="Export chart"
				/>
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item icon={<Icon name="copy" />} onClick={handleCopyPng}>
					Copy as PNG
				</Menu.Item>
				<Menu.Item icon={<Icon name="download" />} onClick={handleDownloadPng}>
					Download PNG
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
}
